module.exports = __webpack_public_path__ + "mountain.jpg?26d2bea861e67e559c285920c67bb429";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mountain.jpg
// module id = 45
// module chunks = 0